import React, {useState, useRef, useEffect, Fragment} from 'react';
import SliderRegistriTemplates from '../SliderRegistriTemplates'
import { useStateContext } from '../../context/StateContext';
import Divider from '../frontend_components/Divider';
import TrueFalseToggle from '../TrueFalseToggle';
import VisDiv from '../frontend_components/VisDiv';
import TextHighlight from '../frontend_components/TextHighlight';
import {FiEdit} from 'react-icons/fi'
import {AiFillCloseCircle} from 'react-icons/ai';
import NonConformityPin from '../NonConformityPin';
import SaveButton from '../frontend_components/SaveButton';
import { errorAlert, keyId, sortByLabel, successAlert, addValueForDropdown } from '../../lib/utils';
import { useCreateReplace } from '../../hooks/mutations';
import PromiseQueue from 'p-queue'
import Loading from '../Loading';
import { useQueryClient } from '@tanstack/react-query';
import FieldDropdown from '../FieldDropdown';
import { ReferencesArrayBox } from './ManagementModules';
import { referenceDoc, richEditorDoc } from '../gestioneDatabase/Docs';
import { create, over, set } from 'lodash';
import { v4 as uuidv4 } from 'uuid'; 
import { IoMdCloseCircle } from "react-icons/io";
import InsertNewSupplyCustomerProduct from '../InsertNewSupplyCustomerProduct';
import DeviceTemplatesManagement from './DeviceTemplatesManagement';



const SupplyDevices = ({data}) => {
    const {customer,  setLoading, newSupplyCustomerProduct, setNewSupplyCustomerProduct, newPresidioModule, setNewPresidioModule} = useStateContext()
    const{priceLists, templateRegisters, deviceProperties, lists, dataModules, laws, products, suppliers, customerProducts, presidioModules, nonConformities} = data
    const [registerTemplate, setRegisterTemplate] = useState()
    const[toggleEdit, setToggleEdit] = useState(false)
    const editSizeLeft = toggleEdit ? {width: "30%" } : {}
    const editSizeRight = toggleEdit ? {width: "70%" } : {}
    

    const supplyNonConformities = nonConformities?.filter?.((x)=>x?.supply)
    const supplyNonConformity = nonConformities?.find?.((x)=>x?._id == registerTemplate?.supplyNonConformity?._ref)
    const registerTemplateDevices = registerTemplate?.devices?.map?.((item)=> !Array.isArray(presidioModules) ? undefined : presidioModules?.find?.((y)=>y?._id == item?._ref))

    const supplyCustomerProductsToCreate = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.((x)=>x?.supply)
    const updatedSupplyCustomerProducts = !Array.isArray(supplyCustomerProductsToCreate) ? [] : supplyCustomerProductsToCreate?.map?.((item)=>{
        const cmFilter = (x) => {
            const isInsupplyNonConformities = x?.nonConformities?.some?.((z)=> supplyNonConformities?.some?.(y=>y?._id == z?._ref))
            const bothHaveTemplateRegisters = x?.registers?.some?.((z)=> item?.registers?.some?.(y=>y?._ref == z?._ref))
            const isDeviceInProperties = x?.deviceProperties?.some?.((x)=>item?.deviceProperties?.some?.((y)=>y?._ref == x?._ref))
            const filterString = !x?.supply && !x?.maintenanceTask && x?.devices?.some?.((y)=>y?._ref == item?.devices?.[0]?._ref)
            if(x?.deviceProperties?.length) { return isDeviceInProperties && filterString && isInsupplyNonConformities && bothHaveTemplateRegisters}
            if(isInsupplyNonConformities && bothHaveTemplateRegisters && !x?.deviceProperties?.length && !x?.devices?.length) {return true}
            return filterString && isInsupplyNonConformities && bothHaveTemplateRegisters
        }
        const foundCustomerProducts = customerProducts?.filter?.(cmFilter)
        //const scpDoc = {...item, supplyCustomerProducts: foundCustomerProducts?.map?.((x)=>x)}
        const scpDoc = {...item, supplyCustomerProducts: foundCustomerProducts?.map?.((x)=>referenceDoc(x?._id))}
        return scpDoc
    })
    const queryClient = useQueryClient()
    const {mutate: updateDocument} = useCreateReplace({
        onMutate: async (newDoc) => {

            await queryClient.cancelQueries({ queryKey: ['customerProductsReport'] })
            const previousCustomerProducts = queryClient.getQueryData(['customerProductsReport'])
       
            //const doc = newDoc?.doc
            
            queryClient.setQueryData(['customerProductsReport'], (old) =>{ 
                const doc = newDoc?.doc
                const oldData = old?.length > 0 ? old : []
                const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                return newData
            })
            return { previousCustomerProducts }
        },
        onError: (err, newDoc, context) => {
            console.error('Oh no, the update failed: ', err?.message);
            errorAlert("Errore: il documento non é stato aggiornato")
        }
        })
        const createUpdateDocuments = async (docs) => {
            
            const queue = new PromiseQueue({
              concurrency: 12,
              intervalCap: 15,
              interval: 700,
            })
            for(const doc of docs) {
                //console.log("Document tested:", doc)
                 queue.add(() => {
                    return updateDocument({doc: doc})
                  })
            }      
        }
        const testFunction = () => {
            console.log({ 
                updatedSupplyCustomerProducts, 
                updatedSupplyCustomerProductsWithCustomerProducts: updatedSupplyCustomerProducts?.filter?.((x)=>x?.customerProducts?.length),
                withNoDevicesAssigned: updatedSupplyCustomerProducts?.filter?.((x)=>!x?.devices?.length),
                withPropertuesAssigned: updatedSupplyCustomerProducts?.filter?.((x)=>x?.deviceProperties?.length),
                supplyNonConformities,
                priceLists
            })
            //createUpdateDocuments(updatedSupplyCustomerProducts)
        }
  return (
    <div style={{minHeight: "100vh"}} className="split-view">
     <div className='new-device-container half-left' style = {{...editSizeLeft}}>
            <h2>FORNITURA PRESIDI</h2>
            <button onClick={testFunction}>test</button>
            <VisDiv rules={[templateRegisters]}>
                <h4>FILTRA PER FAMIGLIA</h4>
                <SliderRegistriTemplates 
                    registerTemplateFilter={registerTemplate} 
                    setRegisterTemplateFilter={setRegisterTemplate} 
                    templates={!Array.isArray(templateRegisters) ? [] : templateRegisters?.filter?.((x)=>x?.customer?._ref == customer?._id)} 
                    setLoading={setLoading}
                />
            </VisDiv>
            <VisDiv rules={[registerTemplate]}>

                {registerTemplateDevices?.sort?.(sortByLabel)?.map?.((item, index)=>{
                    return(
                        <SupplyDevicePin 
                            toggleEdit={toggleEdit}
                            setToggleEdit={setToggleEdit}
                            setNewSupplyCustomerProduct={setNewSupplyCustomerProduct}
                            setNewPresidioModule={setNewPresidioModule}
                            data={{deviceProperties, priceLists, templateRegisters, registerTemplate, supplyNonConformity, customer, customerProducts, device: item}} key={index}
                             />
                    )
                })}
            </VisDiv>   

    </div>
      <VisDiv rules={[toggleEdit]} style = {{...editSizeRight}} className='new-device-container half-right'>
        <div style={{position: "fixed", height: "80vh", display: "flex", flexDirection: "column", paddingRight:"20px"}} >
            <div className="titleCloseBtn">
                <button
                onClick={() => {
                    setToggleEdit(false);
                    setNewSupplyCustomerProduct(undefined);
                    setNewPresidioModule(undefined)
                    //console.log("close", {newSupplyCustomerProduct})
                }}
                >
                <IoMdCloseCircle size={45}/>
                </button>
            </div>
            <VisDiv style={{overflowy:"auto", height:"100%"}} rules={[newSupplyCustomerProduct]}>
                <InsertNewSupplyCustomerProduct data={{priceLists, customerProducts: customerProducts?.filter?.(x=>!x?.supply), supplyCustomerProducts: customerProducts?.filter?.(x=>x?.supply), nonConformities, templateRegisters, presidioModules, deviceProperties, lists, dataModules, laws, products, suppliers }}/>
            </VisDiv>
            <VisDiv style={{overflowy:"auto", height:"100%", width:"100%"}} rules={[newPresidioModule]}>
                <DeviceTemplatesManagement data={{templateRegisters, presidioModules}}/>
            </VisDiv>

        </div>

      </VisDiv>
    </div>
  )
}

export default SupplyDevices

export const SupplyDevicePin = ({toggleEdit, setToggleEdit, setNewSupplyCustomerProduct, setNewPresidioModule, data={}}) => {

    const {deviceProperties, supplyNonConformity, customerProducts, device, registerTemplate, templateRegisters, priceLists, customer} = data
    const supplyCustomerProducts = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.((x)=>x?.supply)
    const customerProductsInNonConformity = customerProducts?.filter?.((x)=>!x?.supply && x?.nonConformities?.some?.(y=>y?._ref == supplyNonConformity?._id))
    const deviceSupplyCustomerProducts = supplyCustomerProducts?.filter?.((x)=>x?.registers?.some?.((z)=> registerTemplate?._id == z?._ref) && x?.devices?.some?.((y)=>y?._ref == device?._id))
    const customerProductsForDevice = customerProducts?.find((x)=>x?.label?.includes(device?.labe))
    const queryClient = useQueryClient()

            const {mutate: updateDocument} = useCreateReplace({
            onMutate: async (newDoc) => {
    
                await queryClient.cancelQueries({ queryKey: ['customerProductsReport'] })
                const previousData = queryClient.getQueryData(['customerProductsReport'])
           
                //const doc = newDoc?.doc
                
                queryClient.setQueryData(['customerProductsReport'], (old) =>{ 
                    const doc = newDoc?.doc
                    const oldData = old?.length > 0 ? old : []
                    const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
                    return newData
                })
                return {previousData}
            },
    
            onError: (err, newDoc, context) => {
                console.error('Oh no, the update failed: ', err?.message)
                errorAlert("ERRORE; Il documento non è stato modificato Ricarica la pagina")
                
                //queryClient.setQueryData(['customerProductsReport'], context?.previousData)
    
            }
            })

    const testFunction = () => {
        console.log({
            device, 
            deviceSupplyCustomerProducts, 
            customerProductsInNonConformity,
            supplyCustomerProducts,
            customerProductsForDevice
        })
    }
    const createSupplyCustomerProduct = () => {

        
        const newCustomerProduct = {
                _type: "customerProduct",
                _id: uuidv4(),
                _key: keyId(),
                label: device?.label,
                customerProductCode:"",
                customer: referenceDoc(customer?._id),
                nonConformities: [{_ref: supplyNonConformity?._id, _type: "reference", _key: keyId()},  
                {
                    "_key": "d81453c9ae46433e81ca0ff87b65d896",
                    "_ref": "26087243-a363-46a4-888f-c609f35bf8be",
                    "_type": "reference"
                },
                {
                    "_key": "381eb97d8460431e9726b1fd1e268369",
                    "_ref": "67d4f994-8e34-4294-bf02-81988ad2b311",
                    "_type": "reference"
                },
                {
                    "_key": "0f132bba003c420092f1169062903ee3",
                    "_ref": "31bb5454-3cdf-4df1-ae62-7beb7943f78b",
                    "_type": "reference"
                },
                ],
                registers: [{_ref: registerTemplate?._id, _type: "reference", _key: keyId()}],
                devices: [{_ref: device?._id, _type: "reference", _key: keyId()}],
                devicesExclude:false,
                deviceProperties: [],
                propertiesExclude: false,
                unit: 1,
                labourHours: 0.5,
                specialisedLabour: false,
                isSign: false,
                supply: true,
                substitution: false,
                maintenanceTask: false,
                allowZero: false,
                details: richEditorDoc(""),
                hideNonConformityDescription: false,
                supplyCustomerProducts: [],
                law: referenceDoc(""),
                supplierProducts: []
        
            }
        if(!Array.isArray(device?.templates) || device?.templates?.length < 1) {
            errorAlert("ERRORE; Il dispositivo non ha registri template")
            return
        }
        console.log({newCustomerProduct})
        updateDocument({doc: newCustomerProduct})

    }
    const goToEditPresidioModule = () => {
        setToggleEdit(true)
        setNewPresidioModule(device)
    }
    return (
        <div style={{borderRadius:"10px", backgroundColor:"#f1f0ef", padding:"10px", marginBottom:"25px"}}>
            <button onClick={testFunction}>test</button>
            <VisDiv  rules={[deviceSupplyCustomerProducts?.length < 1]}>
                 <button className="pdf-button" onClick={createSupplyCustomerProduct}>CREA PRODOTTO FORNITORE</button>
            </VisDiv>
           
            <div style={{margin:"10px 0px 10px 0px", display:"flex", alignItems:"center"}}>
                <VisDiv rules={[!toggleEdit]} style={{display:"flex", alignItems:"center"}}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"red",marginRight:"25px"}} onClick={goToEditPresidioModule}>
                        <FiEdit              
                        size={15}
                        color={"white"}/>
                    </button>
                </VisDiv>
                <h3>PRESIDIO: {device?.label}</h3>
            </div>

            {customerProductsForDevice?.map((x)=>x?.label)}
            <VisDiv rules={[deviceSupplyCustomerProducts?.length > 0]}>
                <div style={{margin:"10px 0px 10px 0px"}}>
                 <p>Prodotti Interni Fornitura:</p>
                </div>
                
                {deviceSupplyCustomerProducts?.sort?.(sortByLabel)?.map?.((item, index)=>{
                    return(
                        <CustomerProductPin
                            setNewSupplyCustomerProduct = {setNewSupplyCustomerProduct}
                            toggleEdit={toggleEdit}
                            setToggleEdit={setToggleEdit}
                            updateDocument={updateDocument} 
                            data={{allDeviceProperties: deviceProperties, priceLists, device, templateRegisters, registerTemplate, customerProductsInNonConformity, supplyNonConformity, customerProducts, supplyProduct: item}} key={index}
                        />
                    )
                })}
            </VisDiv>

        </div>
    )
}

export const CustomerProductPin = ({toggleEdit, setToggleEdit, setNewSupplyCustomerProduct, updateDocument = () => {}, data={}}) => {
    const {allDeviceProperties, customerProductsInNonConformity,  registerTemplate, templateRegisters, priceLists, customerProducts, device, supplyNonConformity, supplyProduct} = data
    const [customerProductToEdit, setCustomerProductToEdit] = useState(supplyProduct)
    const [showAllProducts, setShowAllProducts] = useState(false)
    

    const showProduct = (customerProduct={}) =>  {
        const {deviceProperties, devices} = customerProduct
        if(!customerProduct?._id) return undefined
        if(!deviceProperties && !devices) return customerProduct?.label
        if(deviceProperties?.length < 1 && devices?.length < 1) return customerProduct?.label

        if(deviceProperties?.length < 1 && devices?.length > 0) {
            const isDeviceInProduct = devices?.some?.((x)=>x?._ref == device?._id)
            if(isDeviceInProduct) return customerProduct?.label
            return undefined
        }
        if(deviceProperties?.length  > 0 && devices?.length < 1) {
            const isDeviceInProperties = deviceProperties?.some?.((x)=>customerProductToEdit?.deviceProperties?.some?.((y)=>y?._ref == x?._ref))
            if(isDeviceInProperties) return customerProduct?.label
            return undefined
        }
        if(deviceProperties?.length  > 0 && devices?.length > 0){
            const isDeviceInProduct = devices?.some?.((x)=>x?._ref == device?._id)
            const isDeviceInProperties = deviceProperties?.some?.((x)=>customerProductToEdit?.deviceProperties?.some?.((y)=>y?._ref == x?._ref))
            if(isDeviceInProduct && isDeviceInProperties) return customerProduct?.label
            return undefined
        }
        return undefined
    }
    const productsToShow1 = customerProductsInNonConformity?.map?.(x=>showProduct(x))?.filter?.(y=>y)

    const productsToShow = !Array.isArray(customerProductToEdit?.supplyCustomerProducts) ? [] : customerProductToEdit?.supplyCustomerProducts?.map?.((x)=>{
        const findProduct = customerProducts?.find?.((y)=>y?._id == x?._ref)
        return findProduct
    })
    
    // ADD PRODUCT TO SUPPLY PRODUCT

    const customerProductsOptions = !Array.isArray(customerProducts) ? [] : customerProducts?.filter?.(x=>!x?.supply)?.map?.((item)=>({...item, value: item?.label}))
    
    const isSupplyNonConformityPresent = customerProductToEdit?.nonConformities?.some?.((x)=>x?._ref == supplyNonConformity?._id)
    const isRegisterTemplatePresent = customerProductToEdit?.registers?.some?.((x)=>x?._ref == registerTemplate?._id)
    const areAnyDevicesPresent = customerProductToEdit?.devices?.length > 0
    const areAnyPropertiesPresent = customerProductToEdit?.deviceProperties?.length > 0

    useEffect(()=>{
        if(customerProductToEdit){
            //console.log({customerProductToEdit, isSupplyNonConformityPresent, areAnyDevicesPresent, areAnyPropertiesPresent, isRegisterTemplatePresent})
            setCustomerProductToEdit(supplyProduct)
        }
    },[supplyProduct])
    
    const defaultPriceList = priceLists?.find?.((x)=>x?.default)
    const isInPriceList = defaultPriceList?.products?.some?.((x)=>x?.customerProduct?._ref == customerProductToEdit?._id)
    const addSupplyProductTest = () =>  {
        console.log({supplyProduct, customerProductToEdit, defaultPriceList})
      
    }

    const saveSupplyProduct = (data) => {
        console.log("gsquywsgqwuys", data)
        setCustomerProductToEdit(data)
        updateDocument({doc: data})
    }
    const goToEditProduct = () => {
        console.log("go to edit product")
        setNewSupplyCustomerProduct(supplyProduct)
         setToggleEdit(!toggleEdit)
    }
    const supplyCustomerProductReferenceData = {type: "referenceArray", hideFilter:true, data: customerProducts?.filter((x)=> !x?.supply), propertyName: "supplyCustomerProducts", filterAddById: showAllProducts ? undefined : registerTemplate?._id, filterAddKey: "registers", registerTemplate, checkRegisterTemplate: true, registerTemplateKey: "registers", }
    const editDocument = (doc) => {
        console.log("kjdkqwjdn edit doc",{doc})
    }
    return (
        <div style={{borderRadius:"10px",border:"2px solid grey", backgroundColor:"white", padding:"10px", marginBottom:"5px"}}>
            <div>
                <TrueFalseToggle 
                    value={showAllProducts} 
                    onClick={() =>  setShowAllProducts(!showAllProducts)} 
                    label="Mostra tutti i prodotti" 
                />
                <VisDiv rules={[!toggleEdit]} style={{display:"flex", alignItems:"center"}}>
                    <button type='button' className='round-back-button' style={{backgroundColor:"red",marginRight:"25px"}} onClick={goToEditProduct}>
                        <FiEdit              
                        size={15}
                        color={"white"}/>
                    </button>
                    <h4 onClick={addSupplyProductTest}>{customerProductToEdit?.label}</h4>
                </VisDiv>

                <div style={{padding:"10px"}}>
                    <VisDiv rules={[customerProductToEdit?.deviceProperties?.length > 0]}>
                        {customerProductToEdit?.deviceProperties?.map?.((item, index)=>{
                            const findProperty = allDeviceProperties?.find?.((x)=>x?._id == item?._ref)
                            return (
                                <TextHighlight  style={{marginRight:"5px"}} highlight="blue" key={index}>{findProperty?.label}</TextHighlight>
                                    
                            )
                        })}
                    </VisDiv>
                    <VisDiv style={{color:"red"}} rules={[supplyProduct?.supplierProducts?.length < 1]}>
                        <TextHighlight style={{marginRight:"5px"}} highlight="red">MANCA PRODOTTO FORNITORE</TextHighlight>
                    </VisDiv>
                    <VisDiv style={{color:"orange", marginTop:"13px"}} rules={[!isInPriceList]}>
                        <TextHighlight style={{marginRight:"5px"}} highlight="amber">MANCA PREZZO LISTINO</TextHighlight>
                    </VisDiv>
{/*                     <VisDiv style={{marginTop:"10px"}} rules={[productsToShow?.length > 0]}>
                        <p>Prodotti Associati:</p>
                        {productsToShow?.map?.((product, index)=>{
                            return (
                                <div key={index}>
                                    <p>{product?.label}</p>
                                </div>
                            )
                        })}
                    </VisDiv> */}
{/*                     <FieldDropdown
                        isSearchable="isSearchable"
                        options={customerProductsOptions}
                        onChange={(value) => setCustomerProductToEdit(value)}
                        placeHolder={"SELEZIONA PRODOTTO DA AGGIUNGERE"}
                    /> */}
                    <VisDiv style={{marginTop:"15px"}} rules={[customerProductToEdit]}>
                        {/* <button onClick={addSupplyProductTest}>test cp to edit</button> */}
                        <p>Prodotti Associati:</p>
                        <ReferencesArrayBox 
                            doc={customerProductToEdit} 
                            setDoc={saveSupplyProduct} 
                            referenceData={supplyCustomerProductReferenceData}/>
                            editDocument={editDocument}
                        
                    </VisDiv>
                </div>

            </div>
        </div>
    )
}